import { Injectable } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { OrderService } from '../order/order.service';
import { DefaultResolver } from './default.resolver';

@Injectable()
export class EditOrderResolver extends DefaultResolver implements Resolve<any> {

  constructor(private orderService: OrderService, private router: Router) {
     super();
  }

  resolve(route: ActivatedRouteSnapshot) {
    let routeData = JSON.parse(localStorage.getItem('routeData'));
    let step = this.getRouteParam(route, 'step');
    let orderNumber = this.getRouteParam(route, 'order_number');
    let order = null;

    if (step==1) {
      order = this.orderService.getOrder(orderNumber);
    }

    return order;
  }

  
}



// WEBPACK FOOTER //
// ./src/app/resolvers/edit-order.resolver.ts